import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TypographyWithInfoIcon } from "@rentablo/components";
import {
  DonutChartDataItem,
  DonutChartWithTotal,
} from "@components/Chart/highcharts/DonutChartWithTotal/DonutChartWithTotal";

export const BreakdownBlock = ({
  data,
  name,
  logo,
  total,
  hoveredId,
  setHoveredId,
}: {
  data: DonutChartDataItem[];
  name: string;
  logo: React.ReactNode;
  total: number;
  hoveredId?: string;
  setHoveredId: (id?: string) => void;
}) => {
  const { t } = useTranslation();
  const chartData = !data.length
    ? [{ id: "noData", name: t("common.chartNoData"), value: 1, y: 1 }]
    : data;

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={2}>
        {logo}
        <TypographyWithInfoIcon
          tooltipText={name}
          variant="body1"
          truncate
          hideIcon
        >
          {name}
        </TypographyWithInfoIcon>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
      >
        <DonutChartWithTotal
          chartData={chartData}
          disabled={!data.length}
          selectedId={null}
          hoveredId={hoveredId}
          setHoveredId={setHoveredId}
          height={230}
          width={230}
          showLabels={false}
          tooltipType="percentage"
          centerDetails={{
            value: total,
            innerSize: "60%",
            titleSize: "12px",
            valueSize: "16px",
          }}
        />
      </Box>
    </Box>
  );
};
